import { render, staticRenderFns } from "./pos-terminal-selector.vue?vue&type=template&id=1c70f6e8&scoped=true&"
import script from "./pos-terminal-selector.vue?vue&type=script&lang=ts&"
export * from "./pos-terminal-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c70f6e8",
  null
  
)

export default component.exports